<script lang="ts">
  export let title = 'ຍັງບໍ່ມີຂ່າວສານ'
  export let message = 'ຂະນະນີ້ຍັງບໍ່ມີຂ່າວສານ ຫຼື ປະກາດໃໝ່'
</script>

<div class="rounded-xl bg-white px-5 py-8 text-center shadow-sm">
  <div class="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-gray-400">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M19 13V8a2 2 0 0 0-2-2h-1V5a4 4 0 1 0-8 0v1H7a2 2 0 0 0-2 2v5l-1 2v1h16v-1l-1-2Zm-7 8a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 21Z"/>
    </svg>
  </div>

  <div class="text-base font-semibold text-gray-800">
    {title}
  </div>

  <div class="mt-2 text-sm leading-6 text-gray-500">
    {message}
  </div>
</div>
